import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 text-center" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <h3 className="text-2xl font-black text-white mb-4" data-id="element-115">
          🧩 DESARROLLO INFANTIL 360
        </h3>
        <p className="mb-2" data-id="element-116">
          El sistema de actividades N°1 para el desarrollo infantil en
          Argentina.
        </p>
        <p className="mb-8 italic font-medium text-gray-300" data-id="element-117">
          Acompañá mejor. Viví más.
        </p>

        <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-118">
          <p className="mb-2" data-id="element-119">
            📧 soporteguiadigital360@gmail.com | 🌐 www.guiadigital360.com
          </p>
          <p className="mb-4" data-id="element-120">
            © 2026 DESARROLLO INFANTIL 360™ — Guía Digital 360
          </p>
          <div className="flex justify-center gap-4" data-id="element-121">
            <a href="#" className="hover:text-white transition-colors" data-id="element-122">
              Privacidad
            </a>
            <span data-id="element-123">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-124">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}